import { render, staticRenderFns } from "./EducationContentList.vue?vue&type=template&id=81cbf692&scoped=true&"
import script from "./EducationContentList.vue?vue&type=script&lang=js&"
export * from "./EducationContentList.vue?vue&type=script&lang=js&"
import style0 from "./EducationContentList.vue?vue&type=style&index=0&id=81cbf692&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cbf692",
  null
  
)

export default component.exports